import React, { useCallback, useState } from 'react';
import s from './s.module.less';
import uniprofileAIResume from 'pages/PPAAdvanceSettingPage/imgs/uploadResumeRobot.png';
import UploadUniprofile from 'components/UniprofileResume/UploadUniprofilePage';

interface IProps {
    onUploadSuccess: (documentId?: string | true) => void;
    type?: number | null;
    onClick: (v: number) => void;
    onManualEnter?: () => void;
}

const UniprofileResume = ({
    onUploadSuccess,
    type,
    onClick,
    onManualEnter,
}: IProps) => {
    const handleClick = useCallback((v: number) => {
        onClick(v);
        onUploadSuccess(v === 2 ? true : '');
    }, [onClick]);

    const handleUploadSuccess = useCallback((documentId?: string) => {
        onUploadSuccess(documentId);
    }, []);

    return (
        <div className={s.wrap}>
            <div className={`${s.left} ${type === 2 ? s.minWidth : ''}`}>
                <div className={s.top}>
                    <img className={s.avaImage} src={uniprofileAIResume} />
                    <div className={s.chatBlock}>
                        <div className={s.chatText}>
                            Hi there!  I'm <div className={s.avaLogo}>Ava</div> — your AI assistant. My job is to make your profile shine so patients feel confident choosing you. Share your resume or background with me, and I’ll help turn it into a clear, compelling story that highlights your expertise and builds trust. Let’s get started.
                        </div>
                    </div>
                </div>
                <div className={s.title}>Do you have a resume?</div>
                <div className={s.typeSelection}>
                    <div className={`${s.typeOption} ${type === 1 && s.selected}`} onClick={() => handleClick(1)}>
                        <div className={s.optionInner}>
                            <div className={s.checkbox} />
                            <div className={s.textContent}>
                                Yes, I have a resume ready to upload
                            </div>
                        </div>
                    </div>
                    <div className={`${s.typeOption} ${type === 2 && s.selected}`} onClick={() => handleClick(2)}>
                        <div className={s.optionInner}>
                            <div className={s.checkbox} />
                            <div className={s.textContent}>
                                No, I don’t have a resume yet
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                type === 1 && (
                    <div className={s.right}>
                        <div className={s.title}>Upload your resume here</div>
                        <UploadUniprofile onUploadSuccess={handleUploadSuccess} onManualEnter={onManualEnter} />
                    </div>
                )
            }
        </div>
    );
};

export default UniprofileResume;
